"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniError = void 0;
class OmniError extends Error {
    static is(e) {
        return e instanceof OmniError;
    }
}
exports.OmniError = OmniError;
//# sourceMappingURL=error.js.map